var _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.18429,
    transform: "matrix(0.688809 0.716488 0.688809 -0.716488 9.76333 2.60583)",
    fill: "#2F80ED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.18431,
    transform: "matrix(0.688828 0.716473 0.688828 -0.716473 3.23705 9.39392)",
    fill: "#2F80ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.18431,
    transform: "matrix(0.688828 -0.716473 -0.688828 -0.716473 3.23657 2.6058)",
    fill: "#2F80ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 1.18431,
    transform: "matrix(0.688828 -0.716473 -0.688828 -0.716473 9.76294 9.39413)",
    fill: "#2F80ED"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.2,
    ry: 1.15372,
    transform: "matrix(-4.20255e-08 1 1 4.54649e-08 11.1147 5.99993)",
    fill: "#2F80ED"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.2,
    ry: 1.15372,
    transform: "matrix(-4.20255e-08 1 1 4.54649e-08 1.88516 5.99993)",
    fill: "#2F80ED"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.15372,
    ry: 1.2,
    transform: "matrix(1 0 0 -1 6.49967 1.20002)",
    fill: "#2F80ED"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.15372,
    ry: 1.2,
    transform: "matrix(1 0 0 -1 6.49967 10.8)",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.f45b0dc150de0eb6236eca1b36dd3292.svg";
export { ForwardRef as ReactComponent };